import { useT } from "@/i18n";
import { libLabelsMessages } from "@/i18n/messages/lib-labels";
import type en from "@/i18n/messages/lib-labels/en";
import { cn } from "@/lib/cn";

/**
 * Task status pills. Compact surface dots come from StatusDot in
 * @/components/ui.
 */

/* ---------- Pill (expanded views: popovers, history entries) ---------- */

export const STATUS_PILL: Record<
  string,
  { labelKey: Extract<keyof typeof en, `status${string}`>; className: string }
> = {
  // Task statuses
  backlog: {
    labelKey: "statusBacklog",
    className: "bg-[var(--color-surface-selected)] text-muted",
  },
  todo: {
    labelKey: "statusTodo",
    className: "bg-[var(--color-surface-selected)] text-muted",
  },
  in_progress: {
    labelKey: "statusRunning",
    className: "bg-badge-selected-fill text-status-selected",
  },
  in_review: {
    labelKey: "statusReview",
    className: "bg-warning-muted text-warning",
  },
  done: { labelKey: "statusDone", className: "bg-success-muted text-success" },
  blocked: {
    labelKey: "statusBlocked",
    className: "bg-danger-muted text-danger",
  },
};

/* ---------- Reusable components ---------- */

export function StatusPill({
  status,
  className,
}: {
  status: string;
  className?: string;
}) {
  const t = useT(libLabelsMessages);
  const config = STATUS_PILL[status];
  if (!config) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-1.5 py-px text-canvas-sm font-medium leading-tight",
        config.className,
        className,
      )}
    >
      {t(config.labelKey)}
    </span>
  );
}
